import React, { Ref } from 'react';
import classNames from 'classnames';
import MultiFilterPanel from 'components/MultiFilterPanel';
import MultiSortPanel from 'components/MultiSortPanel';
import { FilterOption } from 'models/Filters';
import { Option } from 'models/Global';
import { SortingDirectionValues } from 'models/Sort';
import { OpenFieldPanelRef } from 'models/FieldFocusableModal';

import './ContactsFilterControls.styles.scss';

type ContactsFilterControlsProps = {
  className?: string;
  filterOptions: FilterOption[];
  multiSortValues: Option[];
  multiSortDirectionTranslation?: SortingDirectionValues;
  multiFilterRef?: Ref<OpenFieldPanelRef>;
  multiSortRef?: Ref<OpenFieldPanelRef>;
};

const ContactsFilterControls: React.FC<ContactsFilterControlsProps> = (
  props,
) => {
  const {
    className,
    filterOptions,
    multiSortValues,
    multiSortDirectionTranslation,
    multiFilterRef,
    multiSortRef,
  } = props;

  const classes = classNames('contacts-filter-controls', className);

  return (
    <div className={classes}>
      <MultiFilterPanel ref={multiFilterRef} filters={filterOptions} />
      <MultiSortPanel
        ref={multiSortRef}
        options={multiSortValues}
        sortDirectionTranslations={multiSortDirectionTranslation}
      />
    </div>
  );
};

export default ContactsFilterControls;
